import app from '../../app'
import Collection from "./Collection";
import Permission from "./Permission";
import optional from "./Support/Optional";

const globals = app.config.globalProperties;

globals.$optional = (obj, ...props) => {
    return optional(obj, ...props);
};

export const collection = list => new Collection(list);

globals.collection = list => collection(list);

globals.$can = ability => (new Permission()).can(ability);

globals.$isAdmin = () => (new Permission()).isAdmin();

globals.$isOnlyDepartmentManager = () => (new Permission()).isOnlyDepartmentManager();


